export const routes = {
    login: "/login",
    registerOrLogin: "/register-or-login",
    register: "/register",
    registerStepTwo: "/register/step-two",
    registerStepThree: "/register/step-three",
    registerStepFour: "/register/step-four",
    registerUpgrade: "/register/upgrade",
    registerFreeTrial: "/register/free-trial",
    upgrade: "/upgrade",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    match: "/match",
    createMatch: "/create-match",
    addResult: "/add-result",
    addMultipleMatches: "/add-multiple-matches",
    addResultDetail: "/formDetail",
    mockWatchMessaging: "/mock-watch",
    teamPacks: "/manage/teamPacks",
    developerTools: "/developer-tools",
    pouchDebug: "/pouch-debug",
    pouchDebugMatch: "/pouch-debug-match",
    garminDebugger: "/garmin-debugger",
    moreProfile: "/more/profile",
    moreNotifications: "/more/notifications",
    moreSubscriptions: "/more/subscriptions",
    subscriptionCancel: "/subscriptions/cancel",
    moreSettings: "/more/settings",
    moreWatchDebug: "/more/watch-debug",
    startWatchPhone: "/more/start-watch-phone",
    moreSupport: "/more/support",
    timerOptions: "/settings/timer-options",
    moreSupportContact: "/support/contact",
    moreIntegrations: "/more/integrations",
    moreSettingsMisconductCodes: "/settings/misconduct-codes",
    moreSettingsEditCustomMisconductCodes:
        "/misconduct-codes/edit-custom",
    moreSettingsTemplates: "/settings/templates",
    moreSettingsTemplatesTemplate: "/templates/template",
    addEditTeamSheet: "/add-edit-teamsheet",
    requestTeamSheet: "/request-teamsheet",
    resultsAddEvent: "/results/event",
    moreSettingsManageWatches: "/settings/manage-watches",
    moreSettingsManageWatchesPair: "/settings/watches/pair",
    moreSettingsSyncCalendar: "/settings/calendar-sync",
    moreSettingsPushConsent: "/settings/push-consent",
    tab: "/tab",
    tabFixtures: "/tab/fixtures",
    tabResults: "/tab/results",
    tabTrends: "/tab/trends",
    tabMore: "/tab/more",
    tabMoreIAP: "/tab/more/iap",
    onboardingGettingStarted: "/onboarding/getting-started",
    onboardingFoundWatch: "/onboarding/found-watch",
    onboardingNoWatchFound: "/onboarding/no-watch-found",
    onboardingPairWatch: "/onboarding/pair-watch",
    onboardingSelectGarmin: "/onboarding/select-garmin-watch",
    onBoardingShareLocationData: "/onboarding/share-location-data",
    onBoardingShareHealthData: "/onboarding/share-health-data",
    permissionsLocationData: "/permissions/location-data",
    permissionsHealthData: "/permissions/health-data",
    onBoardingTimerSettings: "/onboarding/timer-settings",
    onBoardingTimerSettingsStepTwo: "/onboarding/timer-settings-step-two",
    onBoardingSetupComplete: "/onboarding/setup-complete",
    resultsFilters: "/results/filters",
    fixturesFilter: "/fixtures/filters",
    trendsFilter: "/trends/filters",
    review: "/review",
    migrateSystemB: "/migrate-system-b",
    referFriend: "/refer-friend",
    addKnvbMatch: "/add-knvb-match",
    fitnessDataStatus: "/fitness-data-status",
    editMatchDetails: "/edit-match-details",
};

export const sentryDsn =
    "https://b61979c5c9435e1f34c0dc10b9893c66@o946727.ingest.us.sentry.io/4509638131843072";
